import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK'];

export const LandSubsidenceTableConfig = {
  tableInfo: {
    type: 'dataTable',
    title: {
      display: true,
      text: '',
      align: 'center',
      order: 'order-md-2'
    }
  },
  css: {
    tableClass: 'table table-striped table-bordered m-0',
    theadClass: '',
    tbodyClass: ''
  },
  searchFilter: {
    display: true
  },
  breadcrumbCons: {
    show: false,
    queryparams: []
  },
  printButton: {
    display: true,
    text: 'Print',
    align: 'right',
    order: 'order-md-2',
    title: 'Land Subsidence Data'
  },
  paginatorOptions: {
    visible: true,
    limit: -1,
    maxSize: 5,
    directionLinks: 'true',
    autoHide: 'true',
    dropdownOptions: [{
      value: 5,
      display: '5'
    },
    {
      value: 10,
      display: '10'
    },
    {
      value: 15,
      display: '15'
    },
    {
      value: 20,
      display: '20'
    },
    {
      value: 25,
      display: '25'
    },
    {
      value: -1,
      display: 'All'
    }
    ]
  },
  tableHeaderFixerInfo: {
    headerFix: true,
    colFix: true,
    rowFix: false,
    noOfCol: 1,
    height: '500px'
  },
  totalRow: {
    position: 'bottom',
    name: 'TOTAL',
    jsonKey: 'locName',
    colspan: 1,
    class: 'fixed-row'
  },
  indexCons: {
    show: false
  },
  downloadButton: {
    display: true,
    text: 'Download',
    align: 'right',
    order: 'order-md-3'
  },
  downloadOptions: [
    {
      downloadType: 'xlsx',
      downloadFileName: 'Land Subsidence Data',
      downloadAll: true,
      metaData: false
    }
  ],
  columns: []
};

export const LandSubsidenceMapConstants: any = {
  HeatMapUrl: 'landSubsidence/getLandSubsidenceHeatMapData/',
  HeatMapOptions: {
    type: 'Time',
    view: 'Admin',
    clip: true,
    serviceType: 'HeatMap'
  }
}

export const LAND_SUBSIDENCE_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    LAND_SUBSIDENCE_LEGEND: {
      colorValues: [
        { backgroundColor: '#d73027', text: 'Sinking (<-2 mm)', textColor: '#ffffff' },
        { backgroundColor: '#ffffbf', text: 'Stable (-2 to +2 mm)', textColor: '#000000' },
        { backgroundColor: '#1a9850', text: 'Rising (>2 mm)', textColor: '#ffffff' }
      ]
    }
  }
}

export const LAND_SUBSIDENCE_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    'Country Boundaries': {
      source: 'INDIA',
      displayName: 'Country Boundaries',
      name: 'Country Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'odisha:india_boundary',
      layer_name: 'Country Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'LAND_SUBSIDENCE_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundaries': {
      source: 'INDIA',
      displayName: 'District Boundaries',
      name: 'District Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundaries',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'Block Boundaries': {
      source: 'INDIA',
      displayName: 'Block Boundaries',
      name: 'Block Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundaries',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX + 2,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundary': {
      source: 'INDIA',
      displayName: 'District',
      name: 'District Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'LAND_SUBSIDENCE_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Block Boundary': {
      source: 'INDIA',
      displayName: 'Block',
      name: 'Block Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'LAND_SUBSIDENCE_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary Labels': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'District Boundary Labels': {
      source: 'INDIA',
      displayName: 'District Boundary Labels',
      name: 'District Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'state_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'Block Boundary Labels': {
      source: 'INDIA',
      displayName: 'Block Boundary Labels',
      name: 'Block Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX + 2,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'dist_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED',
      crs: 'EPSG4326',
    },
  }
}
